import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import thumb01 from "../../../../assets/images/thumb-blog01.jpg";

interface PostProps {
  post: {
    id: string;
    title: string;
    author: string;
    description: string;
    date: string;
    body: string;
    img: string;
    index: string;
  }
}

export function Post({ post }: PostProps) {
  const history = useNavigate();

  async function onClick(e: any) {
    e.preventDefault();
    history(
      `/destaques/${post.id}`,
      {
        state: {
          post: post
        }
      }
    ); 
  }

  function cleanMarkdown(text: string): string {
    const re = /(?<marks>[`]|\*{1,3}|_{1,3}|~{2})(?<inmarks>.*?)\1|\[(?<link_text>.*)\]\(.*\)/g;
    const re2 = /(?:__|[*#])|\[(.*?)\]\(.*?\)/gm;
    const htmlRe = /<[^>]*(>|$)|&nbsp;|&zwnj;|&raquo;|&laquo;|&gt;/g;
    
    const body = (text.replace(re2, '$1').replace(re, "$<inmarks>$<link_text>")).replace(htmlRe, '');
    const cleanHtmlElement = document.createElement("div");
    cleanHtmlElement.innerHTML = body;
    const cleanBody = cleanHtmlElement.textContent || cleanHtmlElement.innerText;
    return (cleanBody.replace(re2, '$1').replace(re, "$<inmarks>$<link_text>")).replace(htmlRe, '');
  }

  function formatDate(date: string) {
    if (!date) return '';

    const d = date.split('-'); // yyyy-mm-dd
    return `${d[2]}/${d[1]}/${d[0]}`
  }

  return (
    <Content>
      <Thumb>
        <Image src={post.img? post.img : thumb01} />
      </Thumb>
      <Inner>
        <Title>{ post.title }</Title>
        {formatDate(post.date)? (<DateSpan>{ formatDate(post.date) }</DateSpan>) : ('')}
        {post.author? (<Author>{ post.author }</Author>) : ('')}
        <BlogSpacer></BlogSpacer>
        <Description>{ post.description || cleanMarkdown(post.body) }</Description>
        <LinkUI onClick={onClick} to={`/destaques/${post.id}`}>Continue Lendo</LinkUI>
      </Inner>
    </Content>
  );
}

const Content = styled.li`
  max-width: 387px;

  min-width: 340px;
  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    max-width: none;
  }

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    padding: 0;
    margin-left: 0;
    width: calc(100vw - 28px);
    flex: 1;

    &:last-child {
      margin-right: 14px;
    }
  }
`;

const Thumb = styled.div`
  width: 100%;
  height: 220px;
  position: relative;
  overflow: hidden;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    width: 100%;

    > img {
      width: 100%;
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    width: calc(100vw - 28px);
  }
`;

const Image = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const Inner = styled.div``;

const Title = styled.h4`
  color: ${({ theme }) => theme.colors.blue.dark};
  font-size: 26px;
  margin: 16px 0;
`;

const Author = styled.span`
  color: ${({ theme }) => theme.colors.pink.light};
  font-size: 20px;
  margin-bottom: 8PX;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  line-clamp: 4; 
  -webkit-box-orient: vertical;
`;

const Description = styled.p`
  color: ${({ theme }) => theme.colors.gray.darker};
  font-size: 20px;
  margin-bottom: 16px;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  line-clamp: 4; 
  -webkit-box-orient: vertical;
`;

const LinkUI = styled(Link)`
  background: ${({ theme }) => theme.colors.blue.dark};
  color: ${({ theme }) => theme.colors.pink.light};
  border: none;
  margin: 0;
  padding: 2px 8px;
  font-family: 'Coolvetica Condensed', Arial, Helvetica, sans-serif;
  font-size: 20px;
  text-transform: uppercase;
  text-decoration: none;
  cursor: pointer;
`;

const DateSpan = styled.span`
  background: ${({ theme }) => theme.colors.blue.dark};
  color: ${({ theme }) => theme.colors.gray.light};
  display: inline-flex;
  border: none;
  margin-bottom: 8PX;
  padding: 2px 8px;
  font-family: 'Coolvetica Condensed', Arial, Helvetica, sans-serif;
  font-size: 20px;
  text-transform: uppercase;
  text-decoration: none;
`;

const BlogSpacer = styled.hr`
  max-width: 387px;
  height: 1px;
  margin-bottom: 8PX;
  border: none;
  background-color: ${({ theme }) => theme.colors.black.darker};
`;
